if (!customElements.get('glora-appointment-request')) {
  class GloraAppointmentRequest extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.form = this.querySelector('form');
      this.link = this.querySelector('[data-ga-send]');
      this.status = this.querySelector('[data-ga-status]');
      this.config = JSON.parse(this.querySelector('[data-ga-config]').textContent);
      this.date = this.form.elements.visitDate;
      this.date.min = this.today();
      this.form.hidden = false;
      this.applyHash();
      this.sync();
      this.form.addEventListener('input', () => this.sync(), options);
      this.form.addEventListener('change', () => this.sync(), options);
      window.addEventListener('hashchange', () => { this.applyHash(); this.sync(); }, options);
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        const showroom = this.showroomForHash(link?.getAttribute('href'));
        if (showroom) {
          this.form.elements.showroom.value = showroom;
          this.sync();
        }
      }, options);
      window.addEventListener('pageshow', () => this.sync(), options);
      this.link.addEventListener('click', event => {
        this.sync();
        if (!this.form.reportValidity() || !this.link.hasAttribute('href')) {
          event.preventDefault();
          return;
        }
        this.status.textContent = this.config.handoff;
      }, options);
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        this.link.click();
      }, options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.keyBound = false;
    }
    today() {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const part = type => parts.find(item => item.type === type).value;
      return `${part('year')}-${part('month')}-${part('day')}`;
    }
    showroomForHash(hash) {
      return { '#appBlock-t6PH1jCEBsD2kC4qABS68L': 'chennai', '#appointment-chennai': 'chennai', '#appointment-bangalore': 'bangalore' }[hash];
    }
    applyHash() {
      const showroom = this.showroomForHash(window.location.hash);
      if (showroom) this.form.elements.showroom.value = showroom;
    }
    messageURL() {
      const fields = this.form.elements;
      const place = this.config.showrooms[fields.showroom.value];
      const date = this.date.value;
      const time = fields.visitTime.value;
      if (!place || !/^\d{4}-\d{2}-\d{2}$/.test(date) || date < this.today() || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return null;
      const parsed = new Date(date + 'T12:00:00+05:30');
      if (!Number.isFinite(parsed.getTime())) return null;
      const dateParts = date.split('-').map(Number);
      if (parsed.getUTCFullYear() !== dateParts[0] || parsed.getUTCMonth() + 1 !== dateParts[1] || parsed.getUTCDate() !== dateParts[2]) return null;
      const phone = String(place.phone).replace(/\D/g, '');
      if (!/^\d{10,15}$/.test(phone)) return null;
      const displayDate = new Intl.DateTimeFormat(document.documentElement.lang || 'en-IN', { timeZone: 'Asia/Kolkata', day: 'numeric', month: 'long', year: 'numeric' }).format(parsed);
      const lines = [this.config.messageIntro, '', `${this.config.labels.showroom}: ${place.name}`, `${this.config.labels.date}: ${displayDate}`, `${this.config.labels.time}: ${time} IST (UTC+05:30)`];
      for (const [field, label] of [['fullName', 'name'], ['interest', 'interest'], ['notes', 'notes']]) {
        const value = fields[field].value.trim();
        if (value) lines.push(`${this.config.labels[label]}: ${value}`);
      }
      lines.push('', this.config.messageEnd);
      return 'https://wa.me/' + phone + '?text=' + encodeURIComponent(lines.join('\n'));
    }
    sync() {
      this.date.min = this.today();
      this.status.textContent = '';
      const url = this.messageURL();
      if (url) this.link.href = url;
      else this.link.removeAttribute('href');
      this.link.setAttribute('role', url ? 'link' : 'button');
      this.link.tabIndex = 0;
      if (!this.keyBound) {
        this.link.addEventListener('keydown', event => {
          if (event.key === ' ' || (event.key === 'Enter' && !this.link.hasAttribute('href'))) {
            event.preventDefault();
            this.link.click();
          }
        }, { signal: this.abort.signal });
        this.keyBound = true;
      }
    }
  }
  customElements.define('glora-appointment-request', GloraAppointmentRequest);
}
